import { render, staticRenderFns } from "./scGPEA_GSEA.vue?vue&type=template&id=8a3d65b2&"
import script from "./scGPEA_GSEA.vue?vue&type=script&lang=js&"
export * from "./scGPEA_GSEA.vue?vue&type=script&lang=js&"
import style0 from "./scGPEA_GSEA.vue?vue&type=style&index=0&id=8a3d65b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports